import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e5850dec&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e5850dec&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5850dec')) {
      api.createRecord('e5850dec', component.options)
    } else {
      api.reload('e5850dec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e5850dec&lang=pug", function () {
      api.rerender('e5850dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/account/profile/edit/index.vue"
export default component.exports